import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetChannelsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-channels-paginated.form-default-values';
import { GetChannelsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-channels-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterChannelListContextProvider,
  useChannelListContext,
} from '../channel-list.context';
import { ChannelListFilterFormController } from './channel-list-filter-form/channel-list-filter-form.controller';

interface ChannelListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const ChannelListFilterController = ({
  onCancel,
  onSuccess,
}: ChannelListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useChannelListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetChannelsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.channel-list-filter.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetChannelsPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        // ?? undefined: the isOnline/isMaintenance controls use `null` as
        // their "All" sentinel (see charge-point-is-online-filter /
        // charge-point-is-maintenance-filter controllers) to work around a
        // react-hook-form Controller quirk — normalize back to `undefined`
        // here for the actual query parameters.
        isOnline: fieldValues.isOnline ?? undefined,
        isMaintenance: fieldValues.isMaintenance ?? undefined,
        lastMessageReceivedDate: fieldValues.lastMessageReceivedDate,
        channelOcppStatus: fieldValues.channelOcppStatus,
        customerId: fieldValues.customerId,
        locationId: fieldValues.locationId,
        networkId: fieldValues.networkId,
        tariffId: fieldValues.tariffId,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetChannelsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterChannelListContextProvider data={data}>
      <ChannelListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterChannelListContextProvider>
  );
};
